import React, { Component } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import "../../assets/css/argon-dashboard-react.css"; // Import custom CSS to hide CanvasJS logo and position the dropdown

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class TokenChart extends Component {
  constructor() {
    super();
    this.state = {
      selectedOption: "last7Days", // Default selection
      dataPoints: [], // Empty data initially
    };
  }

  // Method to fetch data from API
  fetchData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/orders`);
      const data = await response.json();

      if (data && data.orders) {
        this.processData(data.orders);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // Method to process data based on selected range
  processData = (orders) => {
    const today = new Date();
    let filteredData = [];

    if (this.state.selectedOption === "last7Days") {
      filteredData = this.getLast7DaysData(orders, today);
    } else if (this.state.selectedOption === "allMonths") {
      filteredData = this.getAllMonthsData(orders);
    } else if (this.state.selectedOption === "last7Weeks") {
      filteredData = this.getLast7WeeksData(orders, today);
    }

    this.setState({ dataPoints: filteredData });
  };

  // Filter data for the last 7 days
  getLast7DaysData = (orders, today) => {
    const last7Days = [];

    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i); // Calculate the date for each day in the last 7 days

      const dayData = orders.filter((order) => {
        const orderDate = new Date(order.createdAt);
        return (
          orderDate.getDate() === date.getDate() &&
          orderDate.getMonth() === date.getMonth() &&
          orderDate.getFullYear() === date.getFullYear()
        );
      });

      const totalTokens = dayData.reduce(
        (acc, order) => acc + parseFloat(order.amountWagr),
        0,
      );
      last7Days.push({ x: date, y: totalTokens });
    }

    return last7Days;
  };

  // Filter data for all months
  getAllMonthsData = (orders) => {
    const monthsData = [];

    orders.forEach((order) => {
      const orderDate = new Date(order.createdAt);
      const month = orderDate.getMonth();
      const year = orderDate.getFullYear();

      const existingMonth = monthsData.find(
        (data) => data.x.getMonth() === month && data.x.getFullYear() === year,
      );

      if (existingMonth) {
        existingMonth.y += parseFloat(order.tokens);
      } else {
        monthsData.push({
          x: new Date(year, month),
          y: parseFloat(order.tokens),
        });
      }
    });

    return monthsData;
  };

  // Filter data for the last 7 weeks
  getLast7WeeksData = (orders, today) => {
    const last7Weeks = [];

    for (let i = 6; i >= 0; i--) {
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - i * 7); // Start of the week
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // End of the week

      const weekData = orders.filter((order) => {
        const orderDate = new Date(order.createdAt);
        return orderDate >= startOfWeek && orderDate <= endOfWeek;
      });

      const totalTokens = weekData.reduce(
        (acc, order) => acc + parseFloat(order.tokens),
        0,
      );
      last7Weeks.push({ x: startOfWeek, y: totalTokens });
    }

    return last7Weeks;
  };

  // Handle dropdown change to update the selected option and chart data
  handleDropdownChange = (event) => {
    const selectedOption = event.target.value;
    this.setState({ selectedOption }, () => {
      this.fetchData(); // Fetch data again whenever the selection changes
    });
  };

  // Run initial fetch on component mount
  componentDidMount() {
    this.fetchData();
  }

  render() {
    const options = {
      animationEnabled: true,
      theme: "light2", // Set the default theme
      title: {
        text: "Token Sale Graph",
        fontColor: "#FFFFFF", // Set title color to white
      },
      backgroundColor: "black", // Set the background color to dark
      axisX: {
        valueFormatString:
          this.state.selectedOption === "last7Days"
            ? "DD MMM"
            : this.state.selectedOption === "last7Weeks"
              ? "DD MMM"
              : "MMM", // Dynamic X-Axis format
        labelFontColor: "#B0B0B0", // Axis X labels in light grey
        lineColor: "#B0B0B0", // Axis line color in light grey
        tickColor: "#B0B0B0", // Tick marks color in light grey
      },
      axisY: {
        title: "Tokens",
        labelFontColor: "#B0B0B0", // Axis Y labels in light grey
        lineColor: "#B0B0B0", // Axis line color in light grey
        tickColor: "#B0B0B0", // Tick marks color in light grey
      },
      creditText: "", // Remove CanvasJS logo text
      creditHref: "", // Remove CanvasJS logo link
      data: [
        {
          type: "spline", // Line chart type
          yValueFormatString: "#,###", // Format the Y axis values
          lineColor: "#FFB000", // Line color set to yellow
          markerColor: "#FFB000", // Marker color set to yellow
          dataPoints: this.state.dataPoints, // Dynamically changing data
        },
      ],
    };

    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "black",
          borderRadius: "10px",
        }}
      >
        <select
          value={this.state.selectedOption}
          onChange={this.handleDropdownChange}
          className="dropdown"
          style={{
            padding: "10px",
            fontSize: "16px",
            borderRadius: "5px",
            backgroundColor: "#333",
            color: "#fff",
            border: "1px solid #666",
            cursor: "pointer",
            marginBottom: "20px", // Add space between the dropdown and the chart
          }}
        >
          <option value="last7Days">Last 7 Days</option>
          <option value="allMonths">All Months</option>
          <option value="last7Weeks">Last 7 Weeks</option>
        </select>

        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default TokenChart;
